import React from 'react';
import { Form, Input, Select, Row, Col, Button } from 'antd';
import DatePicker from 'mopon-react-datepicker2';
import { getStoresList } from '../../modules/Api';
import './custom.css';

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class BulkMessageForm extends React.Component {

    constructor() {
        super();
        this.state = {
            message: null,
            messageable_type: null,
            messageable_id: null,
            from_date: null,
            to_date: null,
            brands: [],
        }
    }
    componentDidMount() {
        getStoresList(``, res => {this.setState({brands: res})});
    }

    componentWillReceiveProps(nextProps) {
    }

    handleSubmit = e => {
        e.preventDefault();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(fieldsValue);
        })
    }

    render() {
        const brands = this.state.brands.filter(s => s.name.startsWith(this.state.filteredStoreKeyword));

        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div id="bulk-message-form">
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={10} offset={1}>

                        <FormItem
                            {...formItemLayout}
                            label="متن پیامک"
                            colon={false}>
                            {
                                getFieldDecorator('message', {
                                    initialValue: this.state.message,
                                    rules: [{
                                        required: true, message: 'لطفا متن پیامک انبوه را وارد نمایید!',
                                    }],
                                })(<Input.TextArea/>)
                            }
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="فروشگاه"
                            colon={false}>
                                {
                                    getFieldDecorator('messageable_id', {
                                        initialValue: null,
                                    })(
                                        <Select filterOption={false} mode="combobox" placeholder="انتخاب فروشگاه" style={{width: '200px'}} showSearch={true} onChange={k => {this.setState({filteredStoreKeyword: k})}}>
                                            {brands.map(s => <Select.Option value={s.id.toString()} key={`ss__${s.id}`}>{s.name}</Select.Option>)}
                                        </Select>
                                    )
                                }
                        </FormItem>


                    </Col>

                    <Col span={11} offset={1}>

                        <FormItem
                            {...formItemLayout}
                            label="تاریخ ثبت‌نام از"
                            style={{direction:"ltr"}}
                            colon={false}>
                            {
                                getFieldDecorator('from_date', {
                                    initialValue: null
                                })(<DatePicker isGregorian={false} timePicker={false}/>)
                            }
                        </FormItem>


                        <FormItem
                            {...formItemLayout}
                            label="تاریخ ثبت‌نام تا"
                            style={{direction:"ltr"}}
                            colon={false}>
                            {
                                getFieldDecorator('to_date', {
                                    initialValue: null
                                })(<DatePicker isGregorian={false} timePicker={false}/>)
                            }
                        </FormItem>
                        
                        <FormItem
                            {...formItemLayout}
                            label="تعداد ارسال"
                            style={{direction:"ltr",width:"40%"}}
                            colon={false}>
                            {getFieldDecorator('limit_users', {
                             
                            })(
                                <Input type={ "number" } style={{direction:'rtl'}} />
                            )}
                    
                        </FormItem>


                    </Col>


                </Row>
                <FormItem>
                    <Button
                        type="primary"
                        htmlType="submit"
                        disabled={hasErrors(getFieldsError()) || this.props.submitted}
                        style={{width: '10%', margin: '0px 45%'}}>
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                    </Button>
                </FormItem>
            </Form>
        </div>
        )
    }
}
BulkMessageForm.defaultValue = {
    initialData: {}
}

export default Form.create({ name: 'horizontal_login' })(BulkMessageForm);


// WEBPACK FOOTER //
// ./src/containers/BulkMessage/form.js